/**
 * I passi del tutorial guidato di Incoming/Outcoming > Ddt.
 *
 * Nessun preparativo, nemmeno per i due menu della pagina: hanno una voce sola
 * ciascuno e il passo la racconta senza doverli aprire, cosi' non serve un
 * `onStop` che richiuda niente.
 *
 * La tabella delle candidate e le righe della bolla stanno dietro un `v-if` sui
 * dati: a bolla vuota quei passi si agganciano in basso e raccontano lo stesso
 * cosa ci si trovera'.
 */
const at = name => `[data-tour-scope="warehouse-ddt"] [data-tour="${name}"]`;

export function createWarehouseDdtTourSteps() {
	return [
		{
			body: "Ddt sta per documento di trasporto: e' la bolla che arriva insieme alla merce del fornitore. Qui si scansiona quello che c'e' dentro il bancale e alla fine si carica tutto in una volta sola. La differenza con l'Inventario e' netta: quello sostituisce le giacenze col numero contato, questo invece SOMMA - le quantita' della bolla si aggiungono a quelle che gia' avevi.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Caricare una bolla',
		},
		{
			body: "Non c'e' niente da cliccare prima di leggere: la pagina ascolta la tastiera per intero, e un lettore barcode per il computer non e' altro che una tastiera che digita in fretta e preme Invio alla fine. Ogni lettura riuscita aggiunge una riga alla bolla con quantita' uno: due pezzi uguali si fanno leggendo due volte, oppure leggendo una volta e correggendo il numero nella lista. Se il codice non e' su nessun prodotto compare un avviso rosso.",
			key: 'scan',
			placement: 'bottom',
			target: at('scan'),
			title: 'Come si compila la bolla',
		},
		{
			body: "Se la pistola non c'e' o il computer e' lontano, il telefono fa da lettore: premi LEGGI CON IL TELEFONO, inquadra il QR che compare e sul telefono si apre la fotocamera - niente app da installare. Legge EAN-13 ed EAN-8, UPC, Code128, Code39, QR e DataMatrix. Ogni codice va confermato con INVIA sul telefono, cosi' un doppio scatto non passa inosservato. Il collegamento resta attivo anche passando alle altre pagine del magazzino, finche' non premi DISCONNETTI. Il codice inviato fa esattamente quello che fa la pistola: aggiunge una riga alla bolla con quantita' uno.",
			key: 'phone',
			placement: 'bottom',
			target: at('phone'),
			title: 'Leggere con il telefono',
		},
		{
			body: "Quando lo stesso codice sta su piu' varianti il sistema non sceglie per te: compaiono tutte le candidate con brand, nome, caratteristiche, sku ed ean, e la riga entra nella bolla solo quando premi CONFERMA su quella giusta.",
			key: 'candidates',
			placement: 'top',
			target: at('candidates'),
			timeout: 250,
			title: "Quando il codice e' ambiguo",
		},
		{
			body: "Qui sotto si forma la bolla: una riga per articolo, con data, foto, brand, categoria, modello, nome, variante, sku, fornitore, ean e quantita'. E' un documento in lavorazione - resta dov'e' anche se chiudi la pagina e lo riprendi domani.",
			key: 'list',
			placement: 'bottom',
			/*
			 * L'intestazione, non la tabella intera: una bolla lunga supera l'altezza
			 * dello schermo e il ritaglio coprirebbe tutto il visibile, facendo
			 * sembrare sparito il velo.
			 */
			target: `${at('list')} thead`,
			timeout: 250,
			title: 'Le righe della bolla',
		},
		{
			body: "La quantita' si corregge direttamente nella riga e si salva con il dischetto accanto al campo: piu' veloce che scansionare venti volte lo stesso articolo. I tre pallini a inizio riga hanno una voce sola, Elimina, che toglie la riga dalla bolla - il prodotto resta nel catalogo e la sua giacenza non viene toccata.",
			key: 'row-qt',
			placement: 'left',
			target: at('row-qt'),
			timeout: 250,
			title: 'Correggere una riga',
		},
		{
			body: "Il piu' in alto apre la pagina Aggiungi prodotto, per mettere in bolla un articolo che non riesci a scansionare - codice rovinato, etichetta staccata, prodotto senza barcode. Salvato o annullato, si torna qui.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere a mano',
		},
		{
			body: 'Il cestino butta via tutta la bolla, dopo una richiesta di conferma. Le giacenze dei prodotti restano quelle che erano: si ricomincia da zero senza aver caricato niente.',
			key: 'delete',
			placement: 'bottom',
			target: at('delete'),
			title: 'Buttare via la bolla',
		},
		{
			body: "Le due frecce sono il carico vero e proprio: alla conferma la quantita' di ogni riga si somma alla giacenza della sua variante e la bolla viene svuotata. Non si torna indietro, e premerlo due volte caricherebbe la merce due volte - e' il motivo per cui conviene controllare le quantita' prima, non dopo.",
			key: 'confirm',
			placement: 'bottom',
			target: at('confirm'),
			title: 'Caricare a magazzino',
		},
	];
}
